import { ExpertsState } from '../../../utils/stores/useExpertsStore';
import { ExpertRole } from '../../experts/types/ExpertRole';

export const getExpertInfo = (expertId: string, experts: ExpertsState) => {
  let expertRole;
  let expertRoleString;
  let expertName;
  let expertFamilyName;
  let expertAvatar;
  switch (expertId) {
    case experts.nutritionist?.id:
      expertRole = ExpertRole.Nutritionist;
      expertRoleString = 'Nutrizionista';
      expertName = experts.nutritionist?.data.name;
      expertFamilyName = experts.nutritionist?.data.family_name;
      expertAvatar = experts.nutritionist?.calendly_data.calendly_user.avatar_url
      break;
    case experts.specialist?.id:
      expertRole = ExpertRole.Specialist;
      expertRoleString = 'Specialist';
      expertName = experts.specialist?.data.name;
      expertFamilyName = experts.specialist?.data.family_name;
      expertAvatar = experts.specialist?.calendly_data.calendly_user.avatar_url
      break;
    case experts.physician?.id:
      expertRole = ExpertRole.Physician;
      expertRoleString = 'Medico endocrinologo';
      expertName = experts.physician?.data.name;
      expertFamilyName = experts.physician?.data.family_name;
      expertAvatar = experts.physician?.calendly_data.calendly_user.avatar_url
      break;
    case experts.admin?.id:
      expertRole = ExpertRole.Admin;
      expertRoleString = 'Assistenza clienti';
      expertName = experts.admin?.data.name;
      expertFamilyName = experts.admin?.data.family_name;
      break;
    default:
      throw new Error('Expert not found');
  }
  return { expertRole, expertRoleString, expertName, expertFamilyName, expertAvatar };
};
